import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const bidderGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = authService.user();

  // Check if user is authenticated and has Bidder role
  if (user && user.role === 'Bidder') {
    return true;
  }

  // If user is an Admin, redirect to dashboard
  if (user && user.role === 'Admin') {
    return router.createUrlTree(['/dashboard']);
  }

  // If not authenticated, redirect to login
  return router.createUrlTree(['/login']);
};
